// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SubscriptionPlan = function (x) {
    return x;
};
var tsBridgeSubscriptionPlan = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SubscriptionPlan")("__brandSubscriptionPlan"));
    }
};
var writeSubscriptionPlan = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSubscriptionPlan = Data_Show.showString;
var readSubscriptionPlan = Simple_JSON.readString;
var ordSubscriptionPlan = Data_Ord.ordString;
var newtypeSubscriptionPlan = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSubscriptionPlan = SubscriptionPlan;
var eqSubscriptionPlan = Data_Eq.eqString;
export {
    SubscriptionPlan,
    makeSubscriptionPlan,
    unwrap,
    newtypeSubscriptionPlan,
    eqSubscriptionPlan,
    ordSubscriptionPlan,
    showSubscriptionPlan,
    readSubscriptionPlan,
    writeSubscriptionPlan,
    tsBridgeSubscriptionPlan
};
//# sourceMappingURL=index.js.map
